import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { PenNib, GoogleLogo, ArrowLeft, CheckCircle } from "@phosphor-icons/react";

export default function Auth() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isSignup = location.pathname !== "/login";

  useEffect(() => {
    if (!loading && user) navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#070707] text-white flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute -top-24 left-1/3 h-[420px] w-[420px] rounded-full bg-[#FFD60A]/10 blur-[140px] pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 h-[380px] w-[380px] rounded-full bg-fuchsia-600/10 blur-[140px] pointer-events-none" />

      <button
        data-testid="auth-back-home"
        onClick={() => navigate("/")}
        className="absolute top-6 left-6 inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors"
      >
        <ArrowLeft size={16} /> Back to homepage
      </button>

      <div className="relative w-full max-w-md">
        <div className="flex items-center gap-2 justify-center mb-8">
          <div className="h-9 w-9 rounded-lg flex items-center justify-center" style={{ backgroundColor: "#FFD60A" }}>
            <PenNib weight="fill" size={20} className="text-black" />
          </div>
          <span className="font-display font-extrabold text-xl tracking-tight">FlyerStudio</span>
        </div>

        <div className="rounded-3xl border border-white/10 bg-[#0E0E0E] p-8 shadow-2xl shadow-black/60">
          <h1 data-testid="auth-title" className="font-display font-black text-3xl tracking-tight text-center mb-2">
            {isSignup ? "Create your free account" : "Welcome back"}
          </h1>
          <p className="text-zinc-400 text-sm text-center mb-2">
            {isSignup ? "Get 10 Free Flyer Credits — no card required." : "Sign in to keep designing club-ready flyers."}
          </p>
          {isSignup && (
            <p className="text-zinc-500 text-xs text-center mb-7">
              Premium flyer designs that don't look AI-made.
            </p>
          )}
          {!isSignup && <div className="mb-5" />}

          <button
            data-testid="auth-google-btn"
            onClick={handleLogin}
            className="w-full inline-flex items-center justify-center gap-3 h-12 rounded-full bg-white text-black font-semibold hover:bg-zinc-200 transition-colors"
          >
            <GoogleLogo weight="bold" size={20} /> Continue with Google
          </button>

          {isSignup && (
            <ul className="mt-6 space-y-2.5">
              {["Looks like you paid a designer. You didn't.", "No card, no catch — 10 free credits to start.", "Your first flyer in 30 seconds."].map((t) => (
                <li key={t} className="flex items-start gap-2 text-sm text-zinc-300">
                  <CheckCircle weight="fill" size={16} style={{ color: "#FFD60A" }} className="mt-0.5 shrink-0" /> <span>{t}</span>
                </li>
              ))}
            </ul>
          )}

          <p className="text-center text-xs text-zinc-500 mt-7">
            {isSignup ? "Already have an account? " : "New to FlyerStudio? "}
            <button
              data-testid="auth-switch-mode"
              onClick={() => navigate(isSignup ? "/login" : "/signup")}
              className="font-semibold text-white hover:underline"
            >
              {isSignup ? "Log in" : "Create one free"}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
